// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app{overflow-x:hidden;max-width:100vw;width:100%;box-shadow:0 0 13px -1px #000}", ""]);
// Exports
module.exports = exports;
